import { useState, useEffect } from "react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, PieChart, Pie, Cell, Legend } from "recharts";
import { AlertTriangle, Calendar, Clock, RefreshCw } from "lucide-react";
import { Link, useHistory } from "react-router-dom";
// import "../ManagerInfo/ManagerPatient/CustomcssMain.css";
// import "../loader.css";

function ApiLogs(props) {
    const [stats, setStats] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [lastRefreshed, setLastRefreshed] = useState(new Date());
    const navigate = useHistory();

    // Color palette
    const COLORS = ["#4338ca", "#d97706", "#059669", "#7c3aed", "#e11d48"];

    const fetchErrorStats = async () => {
        setLoading(true);
        try {
            const response = await fetch("https://aiapiv2.elearningdesigncenter.com/GetTtsErrorStats");
            if (!response.ok) {
                throw new Error(`Error: ${response.status}`);
            }
            const data = await response.json();
            setStats(data);
            setLastRefreshed(new Date());
            setError(null);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchErrorStats();

        // Set up auto-refresh every 5 minutes
        const intervalId = setInterval(fetchErrorStats, 5 * 60 * 1000);

        return () => clearInterval(intervalId);
    }, []);

    if (loading && !stats) {
        return (
            <div className="flex items-center justify-center h-64">
                <div className="text-gray-500">Loading statistics...</div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="bg-red-50 border-l-4 border-red-500 p-4 rounded">
                <div className="flex items-center">
                    <AlertTriangle className="h-6 w-6 text-red-500 mr-3" />
                    <p className="text-red-700">Failed to load TTS error statistics: {error}</p>
                </div>
            </div>
        );
    }

    // Format data for charts
    const formatTimeData = stats ? [
        { name: "Today", value: stats.todayCount },
        { name: "This Week", value: stats.thisWeekCount },
        { name: "This Month", value: stats.thisMonthCount }
    ] : [];

    const BackFunc = () => {
        navigate.push("/index");
    };

    return (
        <>
            <div className="page-content-wrapper">
                {loading ? (
                    <div className="page-content d-flex justify-content-center align-items-center">
                        <div className="my-wrapper">
                            <div class="spinner center">
                                <div class="spinner-blade"></div>
                                <div class="spinner-blade"></div>
                                <div class="spinner-blade"></div>
                                <div class="spinner-blade"></div>
                                <div class="spinner-blade"></div>
                                <div class="spinner-blade"></div>
                                <div class="spinner-blade"></div>
                                <div class="spinner-blade"></div>
                                <div class="spinner-blade"></div>
                                <div class="spinner-blade"></div>
                                <div class="spinner-blade"></div>
                                <div class="spinner-blade"></div>
                            </div>
                        </div>

                    </div>
                ) : (
                    <div className="page-content">
                        <div className="page-bar">
                            <div className="page-title-breadcrumb">
                                <div className=" pull-left">
                                    <div className="page-title my-0">API Logs</div>
                                </div>
                            </div>
                            <div className="page-title-breadcrumb">
                                <div className=" pull-right">
                                    <button
                                        type="submit"
                                        className="btn d-inline-block"
                                        style={{ backgroundColor: "#1e2b38", color: "#FFF", border: "1px solid #1e2b38" }}
                                        onClick={BackFunc}
                                    >
                                        {" "}
                                        <i className="fa fa-arrow-left" aria-hidden="true"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="card" style={{ boxShadow: "0 4px 24px rgba(0, 0, 0, 0.06)", borderRadius: "12px", border: "none" }}>
                                            <div className="card-head">
                                                {/* <header>Patient List</header> */}
                                                <div className="tools">
                                                </div>
                                            </div>
                                            <div className="card-body" style={{ padding: "30px", backgroundColor: "#ffffff" }}>
                                                <div className="flex justify-between items-center mb-8" style={{ borderBottom: "1px solid #f3f4f6", paddingBottom: "16px" }}>
                                                    <h2 style={{ fontSize: "24px", fontWeight: "700", color: "#111827", margin: "0", letterSpacing: "-0.025em" }}>TTS Error Statistics</h2>
                                                    <div className="flex items-center">
                                                        <span style={{ color: "#6b7280", fontSize: "14px", display: "flex", alignItems: "center", marginRight: "16px" }}>
                                                            <Clock className="h-4 w-4" style={{ marginRight: "6px" }} />
                                                            Last updated: {lastRefreshed.toLocaleTimeString()}
                                                        </span>
                                                        <button
                                                            onClick={fetchErrorStats}
                                                            style={{ 
                                                                display: "flex", 
                                                                alignItems: "center", 
                                                                padding: "8px 16px", 
                                                                backgroundColor: "#f0f9ff", 
                                                                color: "#0369a1", 
                                                                borderRadius: "6px", 
                                                                border: "none", 
                                                                fontWeight: "500",
                                                                transition: "all 0.2s ease",
                                                                cursor: "pointer"
                                                            }}
                                                            onMouseOver={(e) => e.currentTarget.style.backgroundColor = "#e0f2fe"}
                                                            onMouseOut={(e) => e.currentTarget.style.backgroundColor = "#f0f9ff"}
                                                        >
                                                            <RefreshCw className="h-4 w-4" style={{ marginRight: "8px" }} />
                                                            Refresh Data
                                                        </button>
                                                    </div>
                                                </div>

                                                {stats && (
                                                    <>
                                                        {/* Summary Cards */}
                                                        <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "20px", marginBottom: "30px" }}>
                                                            <div style={{ 
                                                                background: "linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)", 
                                                                borderRadius: "12px", 
                                                                padding: "24px", 
                                                                boxShadow: "0 2px 10px rgba(59, 130, 246, 0.1)",
                                                                border: "1px solid rgba(59, 130, 246, 0.1)"
                                                            }}>
                                                                <h3 style={{ color: "#1e40af", fontWeight: "600", fontSize: "16px", marginBottom: "12px", marginTop: "0" }}>Total Errors</h3>
                                                                <p style={{ fontSize: "32px", fontWeight: "700", color: "#1e3a8a", margin: "0" }}>{stats.totalErrors}</p>
                                                            </div>
                                                            <div style={{ 
                                                                background: "linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%)", 
                                                                borderRadius: "12px", 
                                                                padding: "24px", 
                                                                boxShadow: "0 2px 10px rgba(245, 158, 11, 0.1)",
                                                                border: "1px solid rgba(245, 158, 11, 0.1)"
                                                            }}>
                                                                <h3 style={{ color: "#b45309", fontWeight: "600", fontSize: "16px", marginBottom: "12px", marginTop: "0" }}>Today's Errors</h3>
                                                                <p style={{ fontSize: "32px", fontWeight: "700", color: "#92400e", margin: "0" }}>{stats.todayCount}</p>
                                                            </div>
                                                            <div style={{ 
                                                                background: "linear-gradient(135deg, #f5f3ff 0%, #ede9fe 100%)", 
                                                                borderRadius: "12px", 
                                                                padding: "24px", 
                                                                boxShadow: "0 2px 10px rgba(139, 92, 246, 0.1)",
                                                                border: "1px solid rgba(139, 92, 246, 0.1)"
                                                            }}>
                                                                <h3 style={{ color: "#6d28d9", fontWeight: "600", fontSize: "16px", marginBottom: "12px", marginTop: "0" }}>This Week's Errors</h3>
                                                                <p style={{ fontSize: "32px", fontWeight: "700", color: "#5b21b6", margin: "0" }}>{stats.thisWeekCount}</p>
                                                            </div>
                                                        </div>

                                                        <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "24px", marginBottom: "30px" }}>
                                                            {/* Errors by Time Period */}
                                                            <div style={{ 
                                                                backgroundColor: "#ffffff", 
                                                                borderRadius: "12px", 
                                                                padding: "24px", 
                                                                boxShadow: "0 2px 12px rgba(0, 0, 0, 0.04)",
                                                                border: "1px solid #f3f4f6"
                                                            }}>
                                                                <h3 style={{ color: "#111827", fontWeight: "600", fontSize: "18px", marginBottom: "20px", marginTop: "0" }}>Errors by Time Period</h3>
                                                                <div style={{ height: "300px" }}>
                                                                    <ResponsiveContainer width="100%" height="100%">
                                                                        <BarChart data={formatTimeData} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
                                                                            <XAxis dataKey="name" style={{ fontSize: "12px" }} />
                                                                            <YAxis allowDecimals={false} style={{ fontSize: "12px" }} />
                                                                            <Tooltip 
                                                                                contentStyle={{ 
                                                                                    backgroundColor: "#ffffff", 
                                                                                    border: "none", 
                                                                                    borderRadius: "6px", 
                                                                                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)"
                                                                                }} 
                                                                            />
                                                                            <Bar 
                                                                                dataKey="value" 
                                                                                fill="#4338ca" 
                                                                                radius={[4, 4, 0, 0]} 
                                                                                barSize={60} 
                                                                            />
                                                                        </BarChart>
                                                                    </ResponsiveContainer>
                                                                </div>
                                                            </div>

                                                            {/* Errors by Service */}
                                                            <div style={{ 
                                                                backgroundColor: "#ffffff", 
                                                                borderRadius: "12px", 
                                                                padding: "24px", 
                                                                boxShadow: "0 2px 12px rgba(0, 0, 0, 0.04)",
                                                                border: "1px solid #f3f4f6"
                                                            }}>
                                                                <h3 style={{ color: "#111827", fontWeight: "600", fontSize: "18px", marginBottom: "20px", marginTop: "0" }}>Errors by Service</h3>
                                                                <div style={{ height: "300px" }}>
                                                                    <ResponsiveContainer width="100%" height="100%">
                                                                        <PieChart>
                                                                            <Pie
                                                                                data={stats.errorsByService}
                                                                                cx="50%"
                                                                                cy="50%"
                                                                                labelLine={false}
                                                                                outerRadius={120}
                                                                                innerRadius={60}
                                                                                dataKey="count"
                                                                                nameKey="serviceName"
                                                                                label={({ serviceName, percent }) =>
                                                                                    `${serviceName}: ${(percent * 100).toFixed(0)}%`
                                                                                }
                                                                            >
                                                                                {stats.errorsByService.map((entry, index) => (
                                                                                    <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                                                                ))}
                                                                            </Pie>
                                                                            <Tooltip 
                                                                                formatter={(value) => [`${value} errors`, "Count"]}
                                                                                contentStyle={{ 
                                                                                    backgroundColor: "#ffffff", 
                                                                                    border: "none", 
                                                                                    borderRadius: "6px", 
                                                                                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)"
                                                                                }}
                                                                            />
                                                                            <Legend formatter={(value) => <span style={{ fontSize: "14px", color: "#4b5563" }}>{value}</span>} />
                                                                        </PieChart>
                                                                    </ResponsiveContainer>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Common Error Messages */}
                                                        <div style={{ 
                                                            backgroundColor: "#ffffff", 
                                                            borderRadius: "12px", 
                                                            padding: "24px", 
                                                            boxShadow: "0 2px 12px rgba(0, 0, 0, 0.04)",
                                                            border: "1px solid #f3f4f6"
                                                        }}>
                                                            <h3 style={{ color: "#111827", fontWeight: "600", fontSize: "18px", marginBottom: "20px", marginTop: "0" }}>Most Common Error Messages</h3>
                                                            <div style={{ overflowX: "auto" }}>
                                                                <table style={{ width: "100%", textAlign: "left", borderCollapse: "separate", borderSpacing: "0" }}>
                                                                    <thead>
                                                                        <tr>
                                                                            <th style={{ 
                                                                                padding: "14px 20px", 
                                                                                backgroundColor: "#f9fafb", 
                                                                                borderTopLeftRadius: "8px", 
                                                                                color: "#111827", 
                                                                                fontWeight: "600", 
                                                                                fontSize: "14px",
                                                                                borderBottom: "1px solid #e5e7eb"
                                                                            }}>Error Message</th>
                                                                            <th style={{ 
                                                                                padding: "14px 20px", 
                                                                                backgroundColor: "#f9fafb", 
                                                                                borderTopRightRadius: "8px", 
                                                                                color: "#111827", 
                                                                                fontWeight: "600", 
                                                                                fontSize: "14px",
                                                                                borderBottom: "1px solid #e5e7eb",
                                                                                width: "100px",
                                                                                textAlign: "center"
                                                                            }}>Count</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {stats.commonErrorMessages.map((error, index) => (
                                                                            <tr key={index} style={{ 
                                                                                backgroundColor: index % 2 === 0 ? "#ffffff" : "#f9fafb",
                                                                                transition: "background-color 0.2s"
                                                                            }}
                                                                            onMouseOver={(e) => e.currentTarget.style.backgroundColor = "#f3f4f6"}
                                                                            onMouseOut={(e) => e.currentTarget.style.backgroundColor = index % 2 === 0 ? "#ffffff" : "#f9fafb"}
                                                                            >
                                                                                <td style={{ 
                                                                                    padding: "14px 20px", 
                                                                                    maxWidth: "75%", 
                                                                                    overflow: "hidden", 
                                                                                    textOverflow: "ellipsis",
                                                                                    whiteSpace: "nowrap",
                                                                                    borderBottom: "1px solid #e5e7eb",
                                                                                    fontSize: "14px",
                                                                                    color: "#374151"
                                                                                }}>{error.errorMessage}</td>
                                                                                <td style={{ 
                                                                                    padding: "14px 20px", 
                                                                                    fontWeight: "500",
                                                                                    borderBottom: "1px solid #e5e7eb",
                                                                                    fontSize: "14px",
                                                                                    color: "#111827",
                                                                                    textAlign: "center"
                                                                                }}>
                                                                                    <span style={{
                                                                                        backgroundColor: "#eef2ff",
                                                                                        color: "#4338ca",
                                                                                        padding: "4px 12px",
                                                                                        borderRadius: "16px",
                                                                                        fontWeight: "600",
                                                                                        fontSize: "13px"
                                                                                    }}>
                                                                                        {error.count}
                                                                                    </span>
                                                                                </td>
                                                                            </tr>
                                                                        ))}
                                                                        {stats.commonErrorMessages.length === 0 && (
                                                                            <tr>
                                                                                <td colSpan="2" style={{ 
                                                                                    padding: "20px", 
                                                                                    textAlign: "center", 
                                                                                    color: "#6b7280",
                                                                                    borderBottom: "1px solid #e5e7eb"
                                                                                }}>
                                                                                    No error messages found
                                                                                </td>
                                                                            </tr>
                                                                        )}
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
}

export default ApiLogs;